import ApiClient from './ApiClient';

class BroadcastApi extends ApiClient {
  constructor() {
    super('broadcasts', { accountScoped: true });
  }

  getTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/templates`);
  }

  get(params) {
    return axios.get(`${this.url}/management_index`, {
      params,
    });
  }

  show(params) {
    return axios.get(`${this.url}/${params.template_name}`, {
      params,
    });
  }

  update(id, data) {
    return axios.post(`${this.url}/update`, { id, data });
  }

  getInbox() {
    return axios.get(`${this.url}/inbox/get`);
  }

  getApproved(params) {
    return axios.get(`${this.url}/approved`, {
      params,
    });
  }

  getPending(templateName) {
    return axios.get(`${this.url}/pending/${templateName}`);
  }

  exportExcel(templateName, params) {
    return axios.get(`${this.url}/${templateName}/export`, {
      params,
      responseType: 'blob',
    });
  }

  getUnreadCount() {
    return axios.get(`${this.url}/unread_count`);
  }

  dispatch(payload, inboxId) {
    return axios.post(`${this.url}/${inboxId}`, payload);
  }

  getInboxTemplates(inboxId) {
    return axios.get(`${this.url}/${inboxId}/templates`);
  }
}

export default new BroadcastApi();
